export const MIXED_INSURANCE_BROKERS_WARNING =
  'Las pólizas seleccionadas pertenecen a corredoras distintas. Seleccione pólizas de una misma corredora para continuar.';

export const missingInsuranceBrokerWarning = (numberPolicy) =>
  `La póliza ${numberPolicy} no tiene corredora asignada. Defina la corredora de la póliza antes de continuar.`;

// Same rule as the backend: every selected policy must have a broker and it
// must be the same one. Returns the message to show, or null when it is valid.
export const getInsuranceBrokerWarning = (policies = []) => {
  const selectedPolicies = policies.filter(Boolean);

  const missing = selectedPolicies.find(
    (policy) => policy.insuranceBrokerId == null
  );
  if (missing) {
    return missingInsuranceBrokerWarning(missing.numberPolicy ?? missing.label);
  }

  const brokerIds = new Set(
    selectedPolicies.map((policy) => policy.insuranceBrokerId)
  );
  return brokerIds.size > 1 ? MIXED_INSURANCE_BROKERS_WARNING : null;
};
